import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"background-color":"#ffffff"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"15px","margin-top":"3%"} }, [
  /*#__PURE__*/_createElementVNode("h3", { style: {"width":"100%"} }, "User Registration"),
  /*#__PURE__*/_createElementVNode("hr", { style: {"width":"60%","margin":"0 auto"} }),
  /*#__PURE__*/_createElementVNode("label", null, "Please select the permissions of systems below you are going to use.")
], -1 /* HOISTED */)
const _hoisted_3 = { class: "tbldiv" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("table", {
  id: "permissiontbl1",
  style: {"width":"90%","margin-left":"5%","margin-right":"5%"}
}, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"25%"} }, "Main"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"55%"} }, "Sub"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"10%"} }, "Authority")
  ])
], -1 /* HOISTED */)
const _hoisted_5 = {
  id: "divPermitList",
  style: {"width":"90%","margin-left":"5%","margin-right":"5%","height":"430px","overflow-x":"hidden","overflow-y":"auto"}
}
const _hoisted_6 = {
  id: "permissiontbl",
  style: {"width":"100%"}
}
const _hoisted_7 = { style: {"width":"25%","height":"30.5px"} }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("td", { style: {"width":"55%","height":"30.5px"} }, null, -1 /* HOISTED */)
const _hoisted_9 = {
  class: "chkBox",
  style: {"width":"10%"}
}
const _hoisted_10 = ["id", "onClick"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", { style: {"width":"25%","height":"30.5px"} }, null, -1 /* HOISTED */)
const _hoisted_12 = { style: {"width":"55%","height":"30.5px"} }
const _hoisted_13 = {
  class: "chkBox",
  style: {"width":"10%"}
}
const _hoisted_14 = ["id", "name", "onClick"]
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { style: {"width":"25%","height":"30.5px"} }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("td", { style: {"width":"55%","height":"30.5px"} }, null, -1 /* HOISTED */)
const _hoisted_18 = {
  class: "chkBox",
  style: {"width":"10%"}
}
const _hoisted_19 = ["id", "name", "onClick"]
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { style: {"width":"25%","height":"30.5px"} }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("td", { style: {"width":"55%","height":"30.5px"} }, null, -1 /* HOISTED */)
const _hoisted_23 = {
  class: "chkBox",
  style: {"width":"10%"}
}
const _hoisted_24 = ["id", "onClick"]
const _hoisted_25 = {
  key: 0,
  style: {"width":"25%","height":"30.5px"}
}
const _hoisted_26 = {
  key: 1,
  style: {"width":"25%","height":"30.5px"}
}
const _hoisted_27 = { style: {"width":"55%","height":"30.5px"} }
const _hoisted_28 = {
  class: "chkBox",
  style: {"width":"10%"}
}
const _hoisted_29 = ["id", "name", "onClick"]
const _hoisted_30 = { style: {"float":"left","width":"100px","margin-left":"-22px","margin-top":"10px"} }
const _hoisted_31 = { style: {"float":"right","width":"100px","margin-right":"-37px","margin-top":"10px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["Alert"], {
      alertMessage: $setup.alertMessage,
      alertState: $setup.alertState
    }, null, 8 /* PROPS */, ["alertMessage", "alertState"]),
    _createVNode($setup["Loading"], { isLoading: $setup.isLoading }, null, 8 /* PROPS */, ["isLoading"]),
    _createVNode($setup["Navigation"]),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("table", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.permissionDetail, (info, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              (
              index == 0 &&
              info.mainTitleCode.mainTitleName ==
              $setup.permissionDetail[index + 1].mainTitleCode.mainTitleName
            )
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_7, _toDisplayString(info.mainTitleCode.mainTitleName), 1 /* TEXT */),
                      _hoisted_8,
                      _createElementVNode("td", _hoisted_9, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          id: 'chkHeader' + info.mainTitleCode.mainTitleName,
                          style: {"visibility":"hidden"},
                          name: "chkHeader",
                          onClick: ($event: any) => (
                      $setup.chkHeaderChange(info.mainTitleCode.mainTitleName, index)
                      )
                        }, null, 8 /* PROPS */, _hoisted_10)
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_11,
                      _createElementVNode("td", _hoisted_12, _toDisplayString(info.mainMenuName), 1 /* TEXT */),
                      _createElementVNode("td", _hoisted_13, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          id: 'chk' + index,
                          name: 'chk' + info.mainTitleCode.mainTitleName,
                          onClick: ($event: any) => ($setup.chkChange(info.mainTitleCode.mainTitleName, index))
                        }, null, 8 /* PROPS */, _hoisted_14)
                      ])
                    ])
                  ], 64 /* STABLE_FRAGMENT */))
                : (
              index == 0 &&
              info.mainTitleCode.mainTitleName !=
              $setup.permissionDetail[index + 1].mainTitleCode.mainTitleName
            )
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                      _createElementVNode("td", _hoisted_16, _toDisplayString(info.mainTitleCode.mainTitleName), 1 /* TEXT */),
                      _hoisted_17,
                      _createElementVNode("td", _hoisted_18, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          id: 'chk' + index,
                          name: 'chk' + info.mainTitleCode,
                          onClick: ($event: any) => ($setup.chkChange(info.mainTitleCode, index))
                        }, null, 8 /* PROPS */, _hoisted_19)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      (
                info.mainMenuName != '' &&
                info.mainTitleCode.mainTitleName !=
                $setup.permissionDetail[index - 1].mainTitleCode.mainTitleName
              )
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_20, [
                            _createElementVNode("td", _hoisted_21, _toDisplayString(info.mainTitleCode.mainTitleName), 1 /* TEXT */),
                            _hoisted_22,
                            _createElementVNode("td", _hoisted_23, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                id: 'chkHeader' + info.mainTitleCode.mainTitleName,
                                style: {"visibility":"hidden"},
                                name: "chkHeader",
                                onClick: ($event: any) => (
                      $setup.chkHeaderChange(info.mainTitleCode.mainTitleName, index)
                      )
                              }, null, 8 /* PROPS */, _hoisted_24)
                            ])
                          ]))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("tr", null, [
                        (info.mainMenuName == '')
                          ? (_openBlock(), _createElementBlock("td", _hoisted_25, _toDisplayString(info.mainTitleCode.mainTitleName), 1 /* TEXT */))
                          : (_openBlock(), _createElementBlock("td", _hoisted_26)),
                        _createElementVNode("td", _hoisted_27, _toDisplayString(info.mainMenuName), 1 /* TEXT */),
                        _createElementVNode("td", _hoisted_28, [
                          _createElementVNode("input", {
                            type: "checkbox",
                            id: 'chk' + index,
                            name: 'chk' + info.mainTitleCode.mainTitleName,
                            onClick: ($event: any) => ($setup.chkChange(info.mainTitleCode.mainTitleName, index))
                          }, null, 8 /* PROPS */, _hoisted_29)
                        ])
                      ])
                    ], 64 /* STABLE_FRAGMENT */))
            ], 64 /* STABLE_FRAGMENT */))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("button", {
          class: "button-back",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.backUserInfo()))
        }, "Back")
      ]),
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("button", {
          class: "button-apply",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.insertUserInfo()))
        }, "Apply")
      ])
    ])
  ]))
}